import {
    LEFT_RAIL_STATIC_WIDTH,
    MIN_FOLDER_PANE_WIDTH,
    MAX_FOLDER_PANE_WIDTH,
} from '../internalConstants';
import { isLeftRailVisible } from 'owa-left-rail';

interface LeftNavMinMaxWidhts {
    dataMin: number;
    dataMax: number;
}

/**
 * Gets the min and max values for the left navigation pane widths for resize purposes
 * User can resize the left nav widths within these bounds.
 */
export default function getDataMinMaxWidthsForLeftNav(): LeftNavMinMaxWidhts {
    /**
     * Case 1: When left rail is visible add the left rail widths when determining
     * the bounds for resizing the left nav
     */
    if (isLeftRailVisible()) {
        return {
            dataMin: MIN_FOLDER_PANE_WIDTH + LEFT_RAIL_STATIC_WIDTH,
            dataMax: MAX_FOLDER_PANE_WIDTH + LEFT_RAIL_STATIC_WIDTH,
        };
    }

    /**
     * Case 2: Left rail is not visible only consider folder pane widths
     */
    return {
        dataMin: MIN_FOLDER_PANE_WIDTH,
        dataMax: MAX_FOLDER_PANE_WIDTH,
    };
}
